import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { defineCommand } from '../../concepts/commands/CommandDefinition';
import { AppEvents } from '../AppEvents';
import { PopupManager } from '../popups/PopupManager';
import { addTemplatePopup } from './AddTemplatePopup';

export const templateCreate = defineCommand(
    'templateCreate',
    'Template: Create...',
    async (r, [folderName, boardUrl]: [string, string?]) => {

        if (!folderName) return false;

        if (!boardUrl) {
            const { data } = await r.call(PopupManager).invoke(addTemplatePopup(folderName));
            return data || false;
        }

        const api = r.call(ApiClient);
        const evts = r.call(AppEvents);

        const board = await api.exec(v2.templates.create({
            folder: folderName,
            board: boardUrl,
        }));

        evts.push('board:create', { board });
        return board.id;
    },
);
